import { render, staticRenderFns } from "./ActiveTab.vue?vue&type=template&id=b76cc192&scoped=true"
import script from "./ActiveTab.vue?vue&type=script&lang=js"
export * from "./ActiveTab.vue?vue&type=script&lang=js"
import style0 from "./ActiveTab.vue?vue&type=style&index=0&id=b76cc192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76cc192",
  null
  
)

export default component.exports